import React from 'react';
import { useRouter } from 'next/router';
import { SingleSelect } from '@boatsetter-backup/js-component-lib';
import { boatRentals } from '~/utils/rentals';

interface Option {
  value: string;
  label: string;
}

const BoatRentalsMenu = () => {
  const router = useRouter();

  const rentals = boatRentals;

  if (!rentals.length) return null;

  const options: Option[] = rentals
    .slice()
    .sort((a, b) => a.short.localeCompare(b.short))
    .map((rental) => ({
      value: rental.id,
      label: rental.short,
    }));

  const handleChange = (selected: Option) => {
    router.push(`/boat-rentals/${selected.value}`, undefined, { scroll: false });
  };

  return (
    <SingleSelect
      instanceId={'boat_rentals_menu'}
      options={options}
      onChange={handleChange}
      placeholder="Destinations"
      value={{
        value: '#',
        label: 'Destinations',
      }}
    />
  );
};

export default BoatRentalsMenu;
